import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { CommonStyles, CommonTheme } from '../styles/Styles';
import { reasonsData } from '../Data/AppData'
import Icon from '@material-ui/core/Icon';

export class ReasonsComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reasonsData: reasonsData
    }
  }

  getReasonsMobileView() {
    return (
      <div className={css(CommonStyles.mainContainer)}>
        <h2 className={css(CommonStyles.subTitle)}>
          Why choose us?
        </h2>
        <div className={css(CommonStyles.reasonsContainer)}>
          {this.state.reasonsData.length > 0 &&
            this.state.reasonsData.map((item, index) => {
              return (
                <div
                  className={css(CommonStyles.reasonTextContainer)}
                  key={index}>
                  <Icon className={css(CommonStyles.homeIcon)} color='primary'>{item.icon}</Icon>
                  <h3 className={css(CommonStyles.reasonTitle)}>{item.title}</h3>
                  <p className={css(CommonStyles.reasonText)}>{item.descr}</p>
                </div>
              )
            })}
        </div>
      </div>
    )
  }

  getReasons() {
    return (
      <div className={css(CommonStyles.mainContainer)}>
        <h2 className={css(CommonStyles.subTitle)}>
          Why choose us?
        </h2>
        <div className={css(CommonStyles.reasonsContainer)}>
          <div className={css(CommonStyles.reasonsInnerContainer)}>
            {this.state.reasonsData.length > 0 &&
              this.state.reasonsData.map((item, index) => {
                return (
                  <div
                    className={css(CommonStyles.reasonTextContainer)}
                    key={index}>
                    <Icon className={css(CommonStyles.homeIcon)} color='primary'>{item.icon}</Icon>
                  </div>
                )
              })}
          </div>

          <div className={css(CommonStyles.reasonsInnerContainer)}>
            {this.state.reasonsData.length > 0 &&
              this.state.reasonsData.map((item, index) => {
                return (
                  <div
                    className={css(CommonStyles.reasonTextContainer)}
                    key={index}>
                    <h3 className={css(CommonStyles.reasonTitle)}>{item.title}</h3>
                  </div>
                )
              })}
          </div>

          <div className={css(CommonStyles.reasonsInnerContainer)}>
            {this.state.reasonsData.length > 0 &&
              this.state.reasonsData.map((item, index) => {
                return (
                  <div
                    className={css(CommonStyles.reasonTextContainer)}
                    key={index}>
                    <p className={css(CommonStyles.reasonText)}>{item.descr}</p>
                  </div>
                )
              })}
          </div>

        </div>
      </div>
    )
  }

  render() {
    return (
      <div>
        {window.innerWidth > 1023 ? this.getReasons() : this.getReasonsMobileView()}
      </div>
    )
  }
}

const Styles = StyleSheet.create({
})


// WEBPACK FOOTER //
// ./src/components/ReasonsComponent.js